module.exports = __webpack_public_path__ + "img/13.3-gallery.3ce62b3c.jpg";